import * as React from "react";
import {
  Box,
  Card,
  CardContent,
  Container,
  Divider,
  Typography,
} from "@mui/material";

const PrivacyPolicy = () => {
  const effectiveDate = "December 16, 2025";

  return (
    <Box component="main">
      {/* HERO */}
      <Box
        sx={{
          py: { xs: 5, md: 7 },
          borderBottom: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper",
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h4" component="h1" fontWeight={900} gutterBottom>
            Privacy Policy
          </Typography>
          <Typography color="text.secondary">
            Effective date: {effectiveDate}
          </Typography>
        </Container>
      </Box>

      {/* CONTENT */}
      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
        <Card variant="outlined" sx={{ borderRadius: 3 }}>
          <CardContent>
            {/* WHO WE ARE */}
            <Typography variant="h6" fontWeight={900} gutterBottom>
              Who we are
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              This website is operated by BhamuIntelli Systems LLP (“we”, “us”, “our”). We provide
              software development services and products, primarily focused on the education domain.
            </Typography>

            <Divider sx={{ my: 2 }} />

            {/* INFORMATION WE COLLECT */}
            <Typography variant="h6" fontWeight={900} gutterBottom>
              Information we collect
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              We collect only the information that you voluntarily provide to us, such as your name,
              email address, phone number, organization name, and message content when you contact us
              through email, phone, or any contact form on this website.
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              We do not collect sensitive personal data or information unless explicitly required
              for a specific business engagement.
            </Typography>

            <Divider sx={{ my: 2 }} />

            {/* HOW WE USE INFORMATION */}
            <Typography variant="h6" fontWeight={900} gutterBottom>
              How we use information
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              The information we collect is used strictly for legitimate business purposes,
              including:
            </Typography>
            <Typography variant="body2" color="text.secondary" component="div" sx={{ pl: 2 }}>
              • responding to your inquiries and requests<br />
              • communicating about our services, products, or proposals<br />
              • maintaining internal records related to business communication<br />
              • improving our services and website experience
            </Typography>

            <Divider sx={{ my: 2 }} />

            {/* COOKIES */}
            <Typography variant="h6" fontWeight={900} gutterBottom>
              Cookies and tracking
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              We do not use cookies or tracking technologies to monitor user behavior, advertising,
              or analytics. Our website functions without requiring non-essential cookies.
            </Typography>

            <Divider sx={{ my: 2 }} />

            {/* SHARING */}
            <Typography variant="h6" fontWeight={900} gutterBottom>
              Sharing of information
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              We do not sell, rent, or trade your personal information. Information may be shared
              only with trusted service providers (such as hosting or email services) strictly as
              required to operate this website or communicate with you, and always under appropriate
              confidentiality and security obligations.
            </Typography>

            <Divider sx={{ my: 2 }} />

            {/* RETENTION */}
            <Typography variant="h6" fontWeight={900} gutterBottom>
              Data retention
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              We retain personal information only for as long as necessary to fulfill the purposes
              described in this policy, or as required by applicable laws and regulations.
            </Typography>

            <Divider sx={{ my: 2 }} />

            {/* SECURITY */}
            <Typography variant="h6" fontWeight={900} gutterBottom>
              Security
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              We implement reasonable administrative and technical safeguards to protect personal
              information against unauthorized access, disclosure, or misuse. However, no method of
              transmission over the internet is completely secure.
            </Typography>

            <Divider sx={{ my: 2 }} />

            {/* GRIEVANCE OFFICER */}
            <Typography variant="h6" fontWeight={900} gutterBottom>
              Grievance Redressal
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              In accordance with the Information Technology Act, 2000 and applicable rules, we have
              appointed a Grievance Officer to address any concerns or complaints regarding the
              processing of personal information on this website.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>Grievance Officer:</strong> Authorized Representative<br />
              <strong>Email:</strong> bis9.llp@gmail.com<br />
              <strong>Response Time:</strong> Within 7 working days<br />
              <strong>Jurisdiction:</strong> India
            </Typography>

            <Divider sx={{ my: 2 }} />

            {/* CONTACT */}
            <Typography variant="h6" fontWeight={900} gutterBottom>
              Contact us
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Email: bis9.llp@gmail.com • Phone: +91 9096232337
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Registered Address: SNO 5/2/1 Daffodils, Gulmohar City, Kharadi, Viman Nagar,
              Pune 411014, Maharashtra, India
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
